export default __webpack_public_path__ + "static/media/haus.e0923943.png";